// components/Header.js
"use client";
import Image from "next/image";
import { Loader2, User } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function Header() {
  const { user, loading } = useAuth();

  const handleGoToProfile = () => {
    window.location.href = "/profile";
  };

  return (
    <header className="border-b border-gray-200 fixed top-0 w-full h-[70px] py-3 px-5 flex justify-between items-center bg-white z-100">
      <Image src="/images/moneyclub.webp" alt="Money Club" height={40} width={90} />
      
      {/* Right side content */}
      <div className="flex items-center gap-3">
        {loading ? (
          <div className="text-blue-500">
            <Loader2 className="animate-spin" />
          </div>
        ) : user ? (
          <button 
            onClick={handleGoToProfile}
            className="focus:outline-none"
          >
            <div className="h-10 w-10 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-blue-500/30 cursor-pointer hover:shadow-xl hover:scale-105 transition-all">
              <User className="h-5 w-5 text-white" />
            </div>
          </button>
        ) : (
          <div className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-full px-3 py-1.5">
            <span className="text-gray-500 text-sm font-medium">Sin sesión</span>
          </div>
        )}
      </div>
    </header>
  );
}
